import styled from 'styled-components';

export const HighLevelControls = styled.section`
	grid-row: 1;
	display: grid;
	align-items: center;
`;
